import { useCallback, useMemo } from 'react'
import { Link } from 'react-router-dom'
import { ChevronLeft, Radar } from 'lucide-react'
import { PageHeader } from '@/shell/AppShell'
import { DataTable } from '@/components/DataTable'
import type { AdminColumn } from '@/components/DataTable/types'
import { PERMISSIONS } from '@/lib/permissions'
import { fetchGeoAnomalies, GEO_STR as S, type GeoAnomalyRow } from './geoApi'

/**
 * A11.21 — Geo-anomaliyalar. Imkonsiz-harakat, davlat sakrash, VPN-klaster
 * aniqlashlari. Greenfield `/admin/geo/anomalies` → fetcher fail-soft bo'sh;
 * backend chiqqanda to'ladi.
 */
export function GeoAnomaliesScreen() {
  const columns = useMemo<AdminColumn<GeoAnomalyRow>[]>(
    () => [
      { key: 'detected_at', header: S.detectedAt, type: 'date', width: 150 },
      { key: 'country_code', header: S.code, type: 'id', width: 80 },
      { key: 'kind', header: S.kind, type: 'text', width: 170 },
      { key: 'detail', header: S.detail, type: 'longtext', minWidth: 200 },
      {
        key: 'severity',
        header: S.severity,
        type: 'enum',
        width: 130,
        options: [
          { value: 'low', label: S.sevLow, status: 'active' },
          { value: 'medium', label: S.sevMedium, status: 'review' },
          { value: 'high', label: S.sevHigh, status: 'banned' },
          { value: 'critical', label: S.sevCritical, status: 'blocked' },
        ],
      },
      { key: 'count', header: S.count, type: 'number', width: 100, align: 'right' },
    ],
    [],
  )

  const fetcher = useCallback(fetchGeoAnomalies, [])

  return (
    <>
      <PageHeader
        title={S.anomaliesTitle}
        screenId="A11.21"
        description={S.anomaliesNote}
        actions={
          <Link
            to="/geo"
            className="inline-flex items-center gap-1 rounded-md border border-border-default bg-surface-2 px-2.5 py-1 text-sm text-secondary hover:text-primary"
          >
            <ChevronLeft size={13} />
            {S.backToList}
          </Link>
        }
      />
      <DataTable<GeoAnomalyRow>
        screenId="A11.21"
        permission={PERMISSIONS.COUNTRIES_VIEW}
        columns={columns}
        fetcher={fetcher}
        rowId={(r) => String(r.id)}
        exportable
        emptyState={{ icon: <Radar size={28} strokeWidth={1.5} /> }}
      />
    </>
  )
}
